import React, { useContext, useEffect } from 'react';
import { navigate, useLocation } from '@reach/router';
import { useApolloClient } from '@apollo/react-hooks';
import ls from 'local-storage';
import { AuthContext } from '../../../services/user/AuthProvider';


const LoggedInRouter = ({children}) => {
    const { currentUser, setCurrentUser } = useContext(AuthContext);
    const client = useApolloClient();
    const { pathname } = useLocation();
    // Keep franchise login and invite acceptance available during their redirect.
    const isFranchisePage = pathname.startsWith('/franchise-portal/') ||
        pathname.startsWith('/franchise/') || pathname === '/franchiselogin';
    const shouldLogout = currentUser && currentUser.isSuperadmin !== true && !isFranchisePage;

    useEffect(() => {
        if (!shouldLogout) return;
        ls.clear();
        setCurrentUser(null);
        client.writeData({ data: { loggedIn: false } });
        navigate('/', { replace: true });
    }, [shouldLogout, client, setCurrentUser]);

    if (shouldLogout) return null;
    return (
        <div>
            {children}
        </div>
    )
}

export default LoggedInRouter;
